export const shopFloor = {
  descReady: "طابور عملك والعمليات الجاهزة للتشغيل.",
  descLive: "عرض مباشر للعمل في جميع أنحاء الورشة.",
  allWorkCenters: "جميع مراكز العمل",
  workQueue: "طابور العمل",
  emptyQueueTitle: "لا توجد عمليات في طابور العمل",
  emptyQueueDesc: "ستظهر هنا العمليات المُطلقة مع تقدّم العمل.",
  selectOperation: "اختر عملية",
  selectOperationDesc: "اختر عملية من الطابور لعرض التعليمات والوقت وإجراءات الإبلاغ.",
  noWorkCenter: "بدون مركز عمل",
  dueAt: "تُستحق {date}",
  internal: "داخلي",
  qty: "الكمية",
  start: "بدء",
  pause: "إيقاف مؤقت",
  resume: "استئناف",
  complete: "إكمال",
  unblock: "إزالة الحظر",
  block: "حظر",
  operationStarted: "بدأت العملية",
  operationPaused: "أُوقفت العملية مؤقتاً",
  operationResumed: "استُؤنفت العملية",
  operationUnblocked: "أُزيل الحظر عن العملية",
  operationBlocked: "تم حظر العملية",
  operationCompleted: "اكتملت العملية",
  photoAttached: "تم إرفاق الصورة",
  startedAt: "بدأت في {time}",
  totalTime: "إجمالي الوقت {minutes} دقيقة",
  blockQuestion: "ما الذي يعيق العمل؟",
  blockOperation: "حظر العملية",
  attachPhoto: "إرفاق صورة",
  upload: "رفع",
  operations: "العمليات",
  documents: "الرسومات والمستندات",
  download: "تنزيل",
  issues: "المشكلات",
  reported: "المُبلَّغ",
  goodQuantity: "الكمية السليمة",
  scrapQty: "كمية الهالك",
  scrapReason: "سبب الهالك",
  reworkQty: "كمية إعادة التصنيع",
  reworkReason: "سبب إعادة التصنيع",
  addScrap: "إضافة هالك",
  addRework: "إضافة إعادة تصنيع",
  note: "ملاحظة",
  completeOperation: "إكمال العملية",
};
